"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpScheduleDeleteDialog = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useOpScheduleDelete_1 = __importDefault(require("@opsbase/react-gql-hooks/opschedule/useOpScheduleDelete"));
const react_markdown_1 = require("@opsbase/react-markdown");
const ConfirmDialog_1 = __importDefault(require("@opsbase/web-dialogs/ConfirmDialog"));
const useNotificationActions_1 = __importDefault(require("@opsbase/web-notification/useNotificationActions"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
function OpScheduleDeleteDialog(props) {
    const { id } = props;
    const { raise } = (0, useNotificationActions_1.default)();
    const deleteOpSchedule = (0, useOpScheduleDelete_1.default)();
    const handleAction = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        return raise(deleteOpSchedule({ id }), lib_i18n_1.default.t('opschedule-delete-successful'));
    }), [deleteOpSchedule, id, raise]);
    const deleteText = lib_i18n_1.default.t('delete'), cancelText = lib_i18n_1.default.t('cancel'), text = (0, react_markdown_1.markdown)(lib_i18n_1.default.t('confirm-opschedule-delete', {
        count: 1,
    }));
    return (react_1.default.createElement(ConfirmDialog_1.default, Object.assign({}, props, { onConfirm: handleAction, agreeText: deleteText, notAgreeText: cancelText, color: lib_palette_1.default.error }),
        react_1.default.createElement(Text_1.default, null, text)));
}
exports.OpScheduleDeleteDialog = OpScheduleDeleteDialog;
exports.default = OpScheduleDeleteDialog;
